'use strict';

let vwObj = {
    domReady: function () {
        // this.formLabelScootcher();
        this.jslinks();
        this.mountFeatherlight();
    },
    mountFeatherlight() {
        $.featherlightGallery.prototype.afterContent = function() {
            var caption = this.$currentTarget.find('img').attr('alt');
            this.$instance.find('.featherlight-caption').remove();
            $('<div class="featherlight-caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
        };
        // $('.featherlight').featherlight();
        $('a.featherlight-gallery').featherlightGallery({
            previousIcon: '',     /* Code that is used as previous icon */
            nextIcon: '',         /* Code that is used as next icon */
            galleryFadeIn: 100,          /* fadeIn speed when slide is loaded */
            galleryFadeOut: 300          /* fadeOut speed before slide is loaded */
        });
        setTimeout(function() {
            $(".tripadvisor-widget").toggleClass('tripadvisor-widget-hidden');
        }, 1000);

    },
    jslinks: function () {
        var target;
        let links = document.querySelectorAll('[data-href]');
        for (let i = 0; i<links.length; i++) {
            links[i].classList.add('jslink');
            target = links[i].dataset.href;
            links[i].onclick = function () {
                window.location.href = target;
            }
        }
    },
    tearPosition: function () {
        let panels = document.querySelectorAll('.decoration-border-torn-paper');
        let random = 0;
        for (let i = 0; i<panels.length; i++) {
            // only affect off-screen panels to avoid weirdness
            if (!this.isInViewport(panels[i])) {
                random = Math.floor((Math.random() * 100) + 1);
                panels[i].style.setProperty('--position-x', random + '%');
            }
        }
    },
    isInViewport: function(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
    formLabelScootcher: function () {
        let labels = document.querySelectorAll('.userform label');
        for (let i = 0; i < labels.length; i++) {
            let target = labels[i].htmlFor;
            if (target != '') {

                let fieldinput = document.getElementById(target);

                if (fieldinput.value == '') {
                    labels[i].parentNode.classList.add('set');
                }

                fieldinput.onfocus = function () {
                    labels[i].parentNode.classList.add('up');
                };

                fieldinput.onblur = function () {
                    if (fieldinput.value == '') {
                        labels[i].parentNode.classList.remove('up');
                    }
                };

            }
        }

    },
}


document.addEventListener("DOMContentLoaded", function (event) {
    vwObj.tearPosition();
});

vwObj.domReady();
